export default theme => ({

loader:{
    position: 'fixed',
    top: 0,
    left:0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
    backdropFilter: "blur(5px)",
    backgroundColor: "rgba(255, 255, 255, .8)"
}
})